import React from 'react';

import classNames from 'classnames';

import BlogListStyles from './BlogListWrapper.module.scss';

interface IBlogList {
  textHeader?: React.ReactNode;
  children: React.ReactNode;
  variant?: string;
}

const BlogListWrapper = ({ textHeader, children, variant }: IBlogList) => {
  return (
    <div
      className={classNames(BlogListStyles.wrapper, {
        [BlogListStyles[`blogListWrapper_${variant}`]]: variant,
      })}
    >
      {textHeader && <div className={BlogListStyles.header}>{textHeader}</div>}
      <div className={BlogListStyles.blogList}>{children}</div>
    </div>
  );
};

export default BlogListWrapper;
